import { takeLatest } from 'redux-saga/effects';
import { bookStyleRoomActions } from './bookStyleRoomSlice';
import callFetchStyleRoomAvailabilitySaga from './sagas/callFetchStyleRoomAvailabilitySaga';
import callBookAppointmentSaga from './sagas/callBookAppointmentSaga';

export default function* bookStyleRoomSaga() {
  yield takeLatest(bookStyleRoomActions.fetchStyleRoomAvailability, callFetchStyleRoomAvailabilitySaga);
  yield takeLatest(bookStyleRoomActions.bookAppointment, callBookAppointmentSaga);
}
